/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PrestaAddress model module.
 * @module model/PrestaAddress
 * @version 1.0.0
 */
class PrestaAddress {
    /**
     * Constructs a new <code>PrestaAddress</code>.
     * @alias module:model/PrestaAddress
     */
    constructor() { 
        
        PrestaAddress.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PrestaAddress</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PrestaAddress} obj Optional instance to populate.
     * @return {module:model/PrestaAddress} The populated <code>PrestaAddress</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PrestaAddress();

            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('cp')) {
                obj['cp'] = ApiClient.convertToType(data['cp'], 'String');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('state')) {
                obj['state'] = ApiClient.convertToType(data['state'], 'String');
            }
            if (data.hasOwnProperty('country')) {
                obj['country'] = ApiClient.convertToType(data['country'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} address
 */
PrestaAddress.prototype['address'] = undefined;

/**
 * @member {String} cp
 */
PrestaAddress.prototype['cp'] = undefined;

/**
 * @member {String} city
 */
PrestaAddress.prototype['city'] = undefined;

/**
 * @member {String} state
 */
PrestaAddress.prototype['state'] = undefined;

/**
 * @member {String} country
 */
PrestaAddress.prototype['country'] = undefined;






export default PrestaAddress;

